import { Injectable } from '@angular/core';
import { Entrada } from '../models/entrada.model';
import { HttpClient } from '@angular/common/http';
import {
  share,
  mergeMap,
  shareReplay,
  distinctUntilChanged,
  debounceTime,
  switchMap,
  map,
  take
} from 'rxjs/operators';
import { from, Observable, BehaviorSubject } from 'rxjs';
import { AppConfiguration } from 'src/app/app.configuration';
import { ConfigurationService } from 'src/app/core/conf/configuration.service';
import moment from 'moment';
import { IResponseKoreTarifaDisponible } from '../../gestionar-pausadas/interfaces/gestionar-pausadas.interface';

@Injectable({
  providedIn: 'root'
})
export class EntradasService {
  entradas: Entrada[];

  private entradaSeleccionadaSubject: BehaviorSubject<any>;
  public entradaSeleccionada$: Observable<any>;

  constructor(
    private config: AppConfiguration,
    private http: HttpClient,
    private configuration: ConfigurationService
  ) {
    
    this.entradaSeleccionadaSubject = new BehaviorSubject(undefined);
    this.entradaSeleccionada$ = this.entradaSeleccionadaSubject.asObservable();
  }

  public get entradaSeleccionada() {
    return this.entradaSeleccionadaSubject.value;
  }

  public setEntradaSeleccionada(entrada) {
    //console.log('setEntradaSeleccionada :: :: ', entrada)
    this.entradaSeleccionadaSubject.next(entrada);
  }

  getCategorias(cliente?, fecha?) {
    const config = this.configuration.appConfig.getValue();
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    // 
    const body = {
      ConexionIacpos: conexionId,
      TPVId: this.configuration.datosTPVPathValue.pkId,
      CodigoCliente: cliente ? cliente : '0',
      FiltrarPorCliente:   config.DatosResult.AppConfigJsonConfig &&
        config.DatosResult.AppConfigJsonConfig
          .ClienteFiltrarProductosPorCliente,
      Fecha: fecha != null && fecha !== '' ? moment(fecha).format('YYYY/MM/DD') : ''
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetKoreCategorias`, body)
      .pipe(distinctUntilChanged())
      .pipe(shareReplay(1))
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return [];
          }
          return res.DatosResult.ListadoCategoriasDisponibles;
        })
      );
  }

  buscar(terms: Observable<any>, fecha, cliente, categoriaId) {
    return terms
      .pipe(debounceTime(400))
      .pipe(switchMap(() => this.getEntradas(categoriaId, fecha, cliente)));
  }

  getEntradasByFilter(
    categoriaId: number,
    fecha?: string,
    tpvId?: number,
    clienteCod?: string,
    tipoProducto?: number,
    filtroTipoProductoCod?: string,
    filtroGrupoAsociadoCod?: string,
    filtroTipoNivelCod?: string,
    texto?: string
  ) {
    const config = this.configuration.appConfig.getValue();
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    let body = {
      ConexionIacpos: conexionId,
      TPVId: tpvId ? tpvId : this.configuration.datosTPVPathValue.pkId,
      TipoProducto: tipoProducto,
      CategoriaId: categoriaId,
      TipoProductoCod: filtroTipoProductoCod ? filtroTipoProductoCod : '',
      GrupoAsociadoCod: filtroGrupoAsociadoCod ? filtroGrupoAsociadoCod : '',
      TipoNivelCod: filtroTipoNivelCod ? filtroTipoNivelCod : '',
      FiltrarPorCliente:
        config.DatosResult.AppConfigJsonConfig.ClienteFiltrarProductosPorCliente,
      Texto: texto ? texto : '',
      CodigoCliente: clienteCod ? clienteCod : '0'
    };
    if (fecha) {
      body = Object.assign(body, { Fecha: moment(fecha).format('YYYY/MM/DD') });
    }
    
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`,
        body
      )
      .pipe(distinctUntilChanged())
      .pipe(
        map((res: IResponseKoreTarifaDisponible) => {
          if (!res || !res.DatosResult) {
            return null;
          }
          return res.DatosResult.ListadoKoreTarifasDisponibles;
        })
      );
  }


  getEntradas(
    categoriaId: string,
    fecha?,
    cliente?,
    limite = '9',
    pagina = '1',
    tipoProducto?,
    filtroTipoProductoCod?,
    filtroGrupoAsociadoCod?,
    filtroTipoNivelCod?,
    texto?
  ) {
    const config = this.configuration.appConfig.getValue();
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    let body = {
      ConexionIacpos: conexionId,
      TPVId: this.configuration.datosTPVPathValue.pkId,
      TipoProducto: tipoProducto,
      CategoriaId: categoriaId,
      TipoProductoCod: filtroTipoProductoCod,
      GrupoAsociadoCod: filtroGrupoAsociadoCod,
      TipoNivelCod: filtroTipoNivelCod,
      FiltrarPorCliente:
        config.DatosResult.AppConfigJsonConfig.ClienteFiltrarProductosPorCliente,
      Texto: texto
    };
    if (fecha) {
      body = Object.assign(body, { Fecha: moment(fecha).format('YYYY/MM/DD') });
    }

    /*     if (cliente) {
      if (cliente.Codigo === this.configuration.internetConfig.DatosResult.ClienteId) {
        body = Object.assign(body, { CodigoCliente: '0' });
      } else {
        body = Object.assign(body, { CodigoCliente: cliente.Codigo });
      }
    } else {
      body = Object.assign(body, { CodigoCliente: '0' });
    } */

    body = Object.assign(body, {
      CodigoCliente: cliente ? cliente.Codigo : '0'
    });
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`,
        body
      )
      .pipe(distinctUntilChanged())
      .pipe(shareReplay(1))
      .pipe(
        map((res: any) => {
          if (res.DatosResult === null) {
            return {};
          }
          return res.DatosResult.ListadoKoreTarifasDisponibles;
        })
      );
  }

  // getEntradasMicroservices(
  //   categoriaId: string,
  //   fecha?,
  //   cliente?,
  //   limite = '9',
  //   pagina = '1',
  //   tipoProducto?,
  //   filtroTipoProductoCod?,
  //   filtroGrupoAsociadoCod?,
  //   filtroTipoNivelCod?,
  //   texto?
  // ): Observable<ListadoKoreTarifasDisponible[]> {
  //   console.log('cliente :: : ::', cliente)
  //   const config = this.configuration.appConfig.getValue();
  //   const conexionId = JSON.parse(localStorage.getItem('conexionId'));

  //   let body = {
  //     ConexionIacpos: conexionId,
  //     TPVId: this.configuration.datosTPVPathValue.pkId || null,
  //     TipoProducto: tipoProducto || null,
  //     CategoriaId: categoriaId,
  //     TipoProductoCod: filtroTipoProductoCod || null,
  //     GrupoAsociadoCod: filtroGrupoAsociadoCod,
  //     TipoNivelCod: filtroTipoNivelCod,
  //     FiltrarPorCliente:
  //       config.DatosResult.AppConfigJsonConfig.ClienteFiltrarProductosPorCliente || 0,
  //   };

  //   let queryParams = `TipoElemento=2&FiltrarPorCliente=${body.FiltrarPorCliente}`;

  //   if (cliente) {
  //     queryParams += `&CodigoCliente=${cliente.Codigo}`
  //   }

  //   if (fecha) {
  //     body = Object.assign(body, { Fecha: moment(fecha).format('YYYY/MM/DD') });
  //   }

  //   if (texto) {
  //     let queryName = 'Texto';

  //     console.log('type of the texto de busqueda is NaN:: ::', isNaN(texto))
  //     console.log('type of the texto de busqueda is Finite:: ::', isFinite(texto))

  //     if (!isNaN(texto)) {
  //       queryName = 'Filtro'
  //     }

  //     queryParams += `&${queryName}=${texto}`
  //   }

  //   console.log('filtro por cliente: :::::: :: ', body.FiltrarPorCliente)
  //   console.log('cliente: :::::: :: ', body.FiltrarPorCliente)

  //   return this.http
  //     .get<KoreTarifasDisponiblesResponse>(
  //       `${this.config.getConfig('API_URL_MS')}/api/Tienda/KoreTarifasDisponibles?${queryParams}`
  //     )
  //     .pipe(distinctUntilChanged())
  //     .pipe(shareReplay(1))
  //     .pipe(
  //       map((res: KoreTarifasDisponiblesResponse) => {
  //         console.log('res :: :: :: :: ', res)
  //         if (res === null || res.datosResult === null) {
  //           return [];
  //         }
  //         return res.datosResult.listadoKoreTarifasDisponibles;
  //       })
  //     );
  // }

  getEntradasBotonera(fecha?, cliente?, limite = '24', pagina = '1') {
    const modoPresentacion = this.configuration.appConfig.value.DatosResult
    .AppConfigJsonConfig && this.configuration.appConfig.value.DatosResult
    .AppConfigJsonConfig.ModoPresentacion ?  this.configuration.appConfig.value.DatosResult
      .AppConfigJsonConfig.ModoPresentacion : null;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    let body = {
      ConexionIacpos: conexionId,
      TPVId: this.configuration.datosTPVPathValue.pkId,
      Botonera: '1'
    };
    if (fecha) {
      body = Object.assign(body, { Fecha: fecha.format('YYYY/MM/DD') });
    }
    if (cliente) {
      body = Object.assign(body, {
        CodigoCliente: cliente ? cliente.Codigo : '0'
      });
    }

    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`,
        body
      )
      .pipe(distinctUntilChanged())
      .pipe(shareReplay())
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return [];
          } else if (modoPresentacion === 'BOTONERAFIJA') {
            const tarifas = res.DatosResult.ListadoKoreTarifasDisponibles;
            const posiciones = tarifas.map(t => +t.Orden);
            const posicionMaxima = Math.max(...posiciones);
            const arrTarifas = new Array<any>(posicionMaxima).fill(undefined);
            tarifas.forEach(t => {
              arrTarifas[+t.Orden - 1] = t;
            });
            return arrTarifas;
          } else if (modoPresentacion === 'BOTONERA') {
            const tarifas = res.DatosResult.ListadoKoreTarifasDisponibles;
            return tarifas;
          }
        })
      );
  }

  recalcularPrecio(tpvId, entradas, horaVisita, fecha?, cliente?) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    let entradasString: String = '';
    if (entradas) {
      entradas.forEach(entrada => {
        // const datosEntrada = entrada.split(',');
        // entradasString += '[' + datosEntrada[0] + ',' + datosEntrada[1] + '],';
        entradasString += '[' + entrada + '],';
      });
      entradasString = entradasString.substring(0, entradasString.length - 1);
    }
    const body = {
      ConexionIacpos: conexionId,
      TPVId: tpvId,
      Fecha: fecha ? fecha.format('YYYY/MM/DD') : '',
      // TipoProducto: '1',
      CodigoCliente: cliente ? cliente.Codigo : '0',
      FiltrarPorCliente: 0,
      Items: entradasString,
      HoraVisita: horaVisita + ':00'
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`,
        body
      )
      .pipe(
        map((res: any) => {
          if (res.DatosResult) {
            return res.DatosResult.ListadoKoreTarifasDisponibles;
          }
          return [];
        })
      );
  }

  recalcularCarrito(entradas, fecha?) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPVId: this.configuration.datosTPVPathValue.pkId,
      Fecha: fecha ? moment(fecha).format('YYYY/MM/DD') : '',
      Items: entradas
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`,
        body
      )
      .pipe(
        map((res: any) => {
          if (res.DatosResult) {
            return res.DatosResult.ListadoKoreTarifasDisponibles;
          }
          return [];
        })
      );
  }

  comprobarGrupoMotivoDescuentoSeleccionable(tipoEntradaId){

     return this.getGrupoMotivoDescuento(tipoEntradaId).pipe(take(1)).pipe(map ((datos: any)=>{ 
      if(datos && datos.DatosResult)
      {
        
        
        return true;
      }else{
        
        
        return false;
      }
      }));
  }

  getGrupoMotivoDescuento(tiposEntrada: string) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TiposEntrada: tiposEntrada
    };
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/Configuracion/GetGrupoMotivoSeleccionableXEntrada`,
        body
      )
      .pipe(shareReplay(1));
  }

  getRecintosEntrada(tiposEntrada: any) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TiposEntrada: tiposEntrada
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetRecintosEntrada`, body)
      .pipe(shareReplay(1));
  }

  getSesionesEntreFechas(
    fechaDesde: string,
    fechaHasta: string,
    codigoRecintos: any,
    listadoProductos: any
  ) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const body = {
      ConexionIacpos: conexionId,
      FechaDesde: fechaDesde,
      FechaHasta: fechaHasta,
      Recinto: codigoRecintos,
      listadoProductos: listadoProductos,
      IdentificadorUnico: identificadorUnico
    };
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/Configuracion/TraerSesionesEntreFechas`,
        body
      )
      .pipe(shareReplay(1));
  }

  getDescuentos(grupoID: number, seleccionable?: number) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      GrupoId: grupoID,
      Seleccionable: seleccionable? seleccionable: 2
    };
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/Customan/ObtenerCustomanItemsMotivosGrupos`,
        body
      )
      .pipe(shareReplay(1))
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return null;
          }
          return res.DatosResult.customanItemMotGrupo;
        })
      );
      
  }

  getDescuentosPrueba(listaIds) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    return from(listaIds).pipe(
      mergeMap(id => {
        const body = {
          ConexionIacpos: conexionId,
          GrupoId: id
        };
        return <Observable<any>>(
          this.http
            .post(
              `${this.config.getConfig(
                'API_URL'
              )}api/Customan/ObtenerCustomanItemsMotivosGrupos`,
              body
            )
            .pipe(shareReplay(1))
        );
      })
    );
  }

  //Tipos paraa Filtros
  getFiltroTiposProducto(filtro?: string) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      Filtro: filtro
    };
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/Configuracion/GetTiposProductos`,
        body
      )
      .pipe(shareReplay(1));
  }

  getFiltroGruposAsociado(filtro?: string) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      Filtro: filtro
    };
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/Configuracion/GetGruposAsociados`,
        body
      )
      .pipe(shareReplay(1));
  }

  getFiltroTiposNiveles(filtro?: string) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      Filtro: filtro
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/Configuracion/GetTiposNiveles`,
        body
      )
      .pipe(shareReplay(1));
  }

}
